import React from 'react'

import { MintButton } from '../../styles/PageLayout'

const BtnMintTwo = ({ className, ...props }) => (
  <MintButton
    width="43"
    height="45"
    viewBox="0 0 43 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect x="0.5" y="0.5" width="42" height="44" fill="white" stroke="#591ED8" />
    <path
      d="M28.8926 34.8774V35.9089H19.0364V32.8145H18.0508V36.9404H29.8783V32.8145H28.8926V34.8774Z"
      fill="#591ED8"
    />
    <path d="M12.1367 23.5315V24.563H13.1224V22.5H12.1367V23.5315Z" fill="#591ED8" />
    <path d="M14.1077 25.5947V24.5635H13.1221V25.5947H14.1077Z" fill="#591ED8" />
    <path d="M15.0941 26.6262V25.5947H14.1084V26.6262H15.0941Z" fill="#591ED8" />
    <path d="M16.0794 27.6575V26.626H15.0938V27.6575H16.0794Z" fill="#591ED8" />
    <path d="M17.0648 28.6887V27.6572H16.0791V28.6887H17.0648Z" fill="#591ED8" />
    <path d="M18.0501 29.72V28.6885H17.0645V29.72H18.0501Z" fill="#591ED8" />
    <path d="M19.0364 30.7522V29.7207H18.0508V30.7522H19.0364Z" fill="#591ED8" />
    <path
      d="M19.0361 31.7834V32.8143H28.8923V30.7522H29.878V29.7207H27.9067V31.7828H20.0218V30.7519H19.0361V31.7834Z"
      fill="#591ED8"
    />
    <path d="M28.8926 29.72H29.8782V28.6885H28.8926V29.72Z" fill="#591ED8" />
    <path d="M29.8779 14.248V28.6886H30.8636V13.2168H29.8779V14.248Z" fill="#591ED8" />
    <path
      d="M28.8922 12.1858H27.9065V11.1543H26.9209V20.4374H27.9065V13.2173H29.8778V12.1858H28.8922Z"
      fill="#591ED8"
    />
    <path
      d="M25.9352 10.1223H24.9495V9.09082H23.9639V19.4055H24.9495V11.1538H26.9208V10.1223H25.9352Z"
      fill="#591ED8"
    />
    <path d="M22.9785 8.05957H21.9932V9.09106H23.9642V8.05957H22.9785Z" fill="#591ED8" />
    <path
      d="M21.0078 10.1223V16.311H20.0225V17.3425H21.0078V18.374H21.9938V9.09082H21.0078V10.1223Z"
      fill="#591ED8"
    />
    <path d="M19.0363 15.2793H15.0938V16.3108H20.022V15.2793H19.0363Z" fill="#591ED8" />
    <path d="M14.1084 17.343H15.0941V16.3115H14.1084V17.343Z" fill="#591ED8" />
    <path d="M13.1221 18.3743V19.4058H14.1077V17.3428H13.1221V18.3743Z" fill="#591ED8" />
    <path d="M12.1367 20.4368V21.4683H13.1224V19.4053H12.1367V20.4368Z" fill="#591ED8" />
    <path d="M14.1077 22.5002H15.0934V21.4688H13.1221V22.5002H14.1077Z" fill="#591ED8" />
    <path d="M16.0794 20.4375H15.0938V21.469H16.0794V20.4375Z" fill="#591ED8" />
    <path d="M17.0648 19.4053H16.0791V20.4368H17.0648V19.4053Z" fill="#591ED8" />
    <path d="M18.0501 18.374H17.0645V19.4055H18.0501V18.374Z" fill="#591ED8" />
    <path d="M19.0364 20.4368V19.4053H18.0508V20.4368H19.0364Z" fill="#591ED8" />
    <path d="M19.0361 22.5005V24.5635H20.0218V20.4375H19.0361V22.5005Z" fill="#591ED8" />
    <path d="M17.0645 24.5635V25.5947H19.0358V24.5635H17.0645Z" fill="#591ED8" />
    <path d="M16.0791 23.5312V24.5627H17.0648V23.5312H16.0791Z" fill="#591ED8" />
    <path d="M15.0938 22.5V23.5315H16.0794V22.5H15.0938Z" fill="#591ED8" />
  </MintButton>
)

export default BtnMintTwo
